import React, {Dispatch, forwardRef, SetStateAction, useCallback, useEffect, useRef, useState} from 'react'
import {Get} from '../../../setup'
import {KeywordDataRecord, NaturalReferencingKeywordDataArray, useNaturalReferencing} from '../../../app/@types'
import {TablesWidget29} from '../widgets'

type Props = {
    id: string
    title: string
    show: boolean
    setActiveModalId: Dispatch<SetStateAction<string | null>>
}

const KEYWORD_DATA = process.env.REACT_APP_STATISTICS_KEYWORD_DATA || 'data-keyword'


const KeywordNaturalReferencing = forwardRef<HTMLDivElement, Props>(
    ({id, title, show, setActiveModalId}, ref,
    ) => {

        const {period} = useNaturalReferencing()
        const modalTarget = `kt_modal_keyword_natural_referencing_${id}`
        const [data, setData] = useState<NaturalReferencingKeywordDataArray[]>([])
        const modalClose = useRef<HTMLButtonElement | null>(null)
        const [loading, setLoading] = useState<boolean>(false)


        const fetchData = useCallback(async () => {
            setLoading(true)
            if (show) {
                try {
                    const {data} = await Get<{data: KeywordDataRecord}>({
                        endpoint: KEYWORD_DATA, period, extraParams: {key: title},
                    })
                    const formattedData = Object.entries(data).map(([date, {keyword, ctr, clicks, impressions, position}]) => ({
                        date, keyword, ctr, clicks, impressions, position
                    }))

                    setData(formattedData)
                } catch (e) {
                    console.log(e)
                } finally {
                    setLoading(false)
                }

            }
        }, [period, show])

        useEffect(() => {
            fetchData()
        }, [fetchData])

        const handleModalClose = useCallback(() => {
            modalClose.current?.click()
        }, [])


        return (
            <>
                <div className="modal fade" id={`${modalTarget}`} aria-hidden="true" ref={ref}>
                    <div className={`modal-dialog modal-dialog-centered modal-md`}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1>{title}</h1>
                            </div>
                            <div className="modal-body">
                                {
                                    loading ? (
                                        <div className="text-center py-3">
                                            <span className="spinner-border spinner-border-sm me-2" role="status"
                                                  aria-hidden="true"></span>
                                            Chargement...
                                        </div>
                                    ) : (
                                        data && <TablesWidget29 data={data} />
                                    )}
                                {/*{data && <TablesWidget29 data={data} />}*/}
                            </div>
                            <div className="modal-footer">
                                <button type="button"
                                        className="btn btn-sm btn-light me-2 px-6"
                                        data-bs-dismiss="modal"
                                        ref={modalClose}
                                        onClick={() => {
                                            handleModalClose()
                                            setActiveModalId(null)
                                        }}
                                >
                                    Fermer
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    },
)

export {KeywordNaturalReferencing}

const data = [
    {
        date: '2020-01-03',
        keywordStats: {
            keyword: '',
            clicks: 0,
            impressions: 0,
            ctr: 0,
            position: 0,
        }
    }
]